/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
  "use strict";  

    import SmartCenterSmartTileModel = Meevo.Plugins.SmartCenter.SmartCenterSmartTileModel;

    export class SmartCenterDesignerGrid implements angular.IComponentOptions {
    templateUrl = "app/components/controls/smartCenterDesigner/smartCenterDesignerGrid.component.html";    
    bindings: any = {
      tiles: '<?',
      onTileEdit: '&?',
      onTileRemove: '&?',
      isDisabled: '<?',
      isEditingTile: '<?',
      onSquareCheck: '&?',
      onResizeStart: '&?',
      onResizeStop: '&?',
      onDragStop: '=?',
    }


    controller = class SmartCenterDesignerGridController {

        static $inject = [
            '$locale',
        ];

      // Public members //

      /**
       * Emitted when a tile is requesting to be edited.
       */
      public onTileEdit: Function;

      /**
       * Emitted when a tile is requesting to be removed.
       */
      public onTileRemove: Function;
      public onSquareCheck: Function;
      public onResizeStart: Function;
      public onResizeStop: Function;
      public onDragStop: (tile: SmartCenterSmartTileModel) => void;

      /**
       * The main gridster options. TODO: Strongly type at some point but the current typedefs were causing problems.
       */
      public opts: any;
      public scope: any;

      public tiles: SmartCenterSmartTileModel[];

      // END Public members //

      // Initialization //

        constructor(public $locale: angular.ILocaleService) {
            this.initializeGridOptions();

        }

      private initializeGridOptions(): void {
          let that = this;
        this.opts = {
          columns: 6, // the width of the grid, in columns
          pushing: false, // whether to push other items out of the way on move or resize
          floating: false, // whether to automatically float items up so they stack (you can temporarily disable if you are adding unsorted items with ng-repeat)
          swapping: true, // whether or not to have items of the same size switch places instead of pushing down if they are the same size
          width: 'auto', // can be an integer or 'auto'. 'auto' scales gridster to be the full width of its containing element
          colWidth: 'auto', // can be an integer or 'auto'.  'auto' uses the pixel width of the element divided by 'columns'
          rowHeight: 'match', // can be an integer or 'match'.  Match uses the colWidth, giving you square widgets.
          margins: [10, 10], // the pixel distance between each widget
          outerMargin: true, // whether margins apply to outer edges of the grid
          sparse: false, // "true" can increase performance of dragging and resizing for big grid (e.g. 20x50)
          isMobile: false, // stacks the grid items if true
          mobileBreakPoint: 400, // if the screen is not wider that this, remove the grid layout and stack the items
          mobileModeEnabled: true, // whether or not to toggle mobile mode when screen width is less than mobileBreakPoint
          minColumns: 6, // the minimum columns the grid must have
          minRows: 3, // the minimum height of the grid, in rows
          maxRows: 3,
          defaultSizeX: 1, // the default width of a gridster item, if not specifed
          defaultSizeY: 1, // the default height of a gridster item, if not specified
          minSizeX: 1, // minimum column width of an item
          maxSizeX: null, // maximum column width of an item
          minSizeY: 1, // minumum row height of an item
          maxSizeY: null, // maximum row height of an item
          resizable: {
            enabled: true,
            handles: ['n', 'e', 's', 'w', 'ne', 'se', 'sw', 'nw'],
            start: function (event, $element, widget) {
                //that.checkSquare(widget);
                that.resizeStart(widget);
            }, // optional callback fired when resize is started,
            resize: function (event, $element, widget) { }, // optional callback fired when item is resized,
            stop: function (event, $element, widget) {
                //that.checkSquare(widget);
                that.resizeStop(widget);
            } // optional callback fired when item is finished resizing
          },
          draggable: {
            enabled: true, // whether dragging items is supported
            start: function (event, $element, widget) { }, // optional callback fired when drag is started,
            drag: function (event, $element, widget) { }, // optional callback fired when item is moved,
            stop: function (event, $element, widget) {
              let id = parseInt(widget.id, 10);

              that.onDragStop(that.tiles.filter(tile => tile.id === id)[0]);
            } // optional callback fired when item is finished dragging
          }
        };
      }

      // END Initialization //

      public showPreview(id) {
          return Meevo.Components.Controls.SmartCenterDesignerPropertiesHelper.isPreviewTile(id);
      }

      public showsCurrency(id) {
        // TODO: Make this data driven
        // Tiles that support currency data
        /*
        22	Gross Sales	GrossSales
        43	Membership Monthly Recurring Revenue
        */
        const tileListing = [22, 43, 45, 46, 47, 57];
        return _.contains(tileListing, id);
      }

      public showsCount(id) {
        // TODO: Make this data driven
        return !this.showPreview(id) && !this.showsCurrency(id) && !this.isCustomTileFace(id);
      }

      public isDataTile(tile) {
        return tile.smartTileTypeEnum === Meevo.Model.SmartTileTypeEnum.Data;
      }

      public isImageTile(tile) {
        return tile.smartTileTypeEnum === Meevo.Model.SmartTileTypeEnum.Image;
      }

      public isShortcutTile(tile) {
        return tile.smartTileTypeEnum === Meevo.Model.SmartTileTypeEnum.Shortcut;
      }

      public checkSquare(tileParams) {
          this.onSquareCheck({ tileParams: tileParams });
      }

      public resizeStart(tileParams) {
          this.onResizeStart({tileParams: tileParams})
      }

      public resizeStop(tileParams) {
          this.onResizeStop({ tileParams: tileParams });
      }
      
      // Tile actions //

      private editTile(tile: Model.SmartCenterSmartTile): void {
        this.onTileEdit({ tile: tile });
      }

      private removeTile(tile: Model.SmartCenterSmartTile): void {
        this.onTileRemove({ tile: tile });
      }

      // END Tile actions //
      // Gets Image Uri based on MeevoFile
      private getImageUrl(istoreObj: any) {
          let forp = Model.StorageFileHelper.sourceUri(istoreObj, null);
          return forp
      }

      private isCustomTileFace(id): boolean {
          const tileIds = [Meevo.Model.SmartTileIds.DateCounter];
          return _.contains(tileIds, id);
      }
    }
    
  }


  angular.module("meevo.components.controls")
    .component("smartCenterDesignerGrid", new SmartCenterDesignerGrid());
}
